module.exports = __webpack_public_path__ + "a5a766e14c98bf40be47666b598e37e9.png";